"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ra_data_simple_rest_1 = __importDefault(require("ra-data-simple-rest"));
var react_admin_1 = require("react-admin");
var RALayout_1 = __importDefault(require("../../Layouts/RALayout"));
var react_admin_2 = require("react-admin");
var TeamsComponent_1 = __importDefault(require("../../Components/Teams/TeamsComponent"));
var theme = __assign(__assign({}, react_admin_2.defaultTheme), { sidebar: {
        width: 0,
        closedWidth: 0, // The default value is 55
    } });
var TeamsList = function (_a) {
    var handleRowClick = _a.handleRowClick;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_admin_1.Admin, { theme: theme, dataProvider: (0, ra_data_simple_rest_1.default)("/api/list"), disableTelemetry: true, layout: RALayout_1.default },
            react_1.default.createElement(react_admin_1.Resource, { name: "qteams", list: function (props) { return react_1.default.createElement(TeamsComponent_1.default, __assign({}, props, { handleRowClick: handleRowClick })); } }))));
};
exports.default = TeamsList;
